import Alpine from 'alpinejs';
import { initAll } from '../../utils/Choices';

export default function initInsight() {
  Alpine.data('insight', () => ({
    init() {
      document.addEventListener('readystatechange', async (event: Event) => {
        const target = event.target as Document;
        if (target && target.readyState === 'complete') {
          // @ts-ignore
          const article = this.$el;
          initAll(article);
        }
      });
    },
    share(e: Event) {
      e.preventDefault();
      const url = (e.target as HTMLLinkElement).href;
      const settings = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600';
      window.open(url, '', settings);
    },
  }));
}
